import React from 'react';
import styled from 'styled-components';
import { Grid as MuiGrid, Typography, Box, Tooltip, Link } from '@mui/material';
import { spacing } from '@mui/system';
import PageTitle from './PageTitle';
import { ArrowBack, Info } from '@mui/icons-material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
/**
 * @param pageTitle
 * text for react helmet page title, if @param pageTitle doesn't exist,
 * will use @param title for react helmet page title and page header by default
 * @param enableBackButton
 * boolean to show back button
 * @param onBackButtonClick
 * function to handle back button click
 * */

const Grid = styled(MuiGrid)(spacing);
const HeaderTitleContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

function PageHeader({
  title,
  children,
  subtitle,
  pageTitle,
  enableBackButton = false,
  onBackButtonClick,
  customSubtitle = null,
}) {
  const resolvePageTitle = pageTitle ? pageTitle : title;
  const history = useHistory();

  return (
    <Box sx={{ position: 'relative', mb: 5 }} data-testid="page-header">
      <PageTitle title={resolvePageTitle}></PageTitle>
      <Grid container justifyContent="space-between" alignItems="center" gap={2}>
        <Grid item>
          {enableBackButton && (
            <Typography
              variant="subtitle2"
              display="flex"
              alignItems="center"
              gap={1}
              mb={1}
              onClick={() => (onBackButtonClick ? onBackButtonClick() : history.goBack())}
            >
              <ArrowBack fontSize="small" />
              <Link
                sx={{ textDecoration: 'underline', color: 'inherit', '&:hover': { color: 'gray' }, cursor: 'pointer' }}
              >
                Go Back
              </Link>
            </Typography>
          )}

          <HeaderTitleContainer>
            <Typography variant="h4" display="inline">
              {title}
            </Typography>
            {subtitle && (
              <Tooltip title={subtitle} data-testid="page-header-subtitle">
                <Info
                  sx={(theme) => ({
                    fontSize: '20px',
                    color: (theme) => theme.palette.info.main,
                    ml: 1,
                  })}
                />
              </Tooltip>
            )}
          </HeaderTitleContainer>
          {customSubtitle}
        </Grid>
        <Grid item>
          <Grid item>{children}</Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(PageHeader);
